import React from 'react';
import PropTypes from 'prop-types';
import RequiredSelect from '../elements/required-select';

const UserJobTitleSelector = ({ model, label, disabled }) => {
  const values = [
    { label: 'Supervisor', value: 'Supervisor' },
    { label: 'Store owner', value: 'owner' },
    { label: 'Sales assistant', value: 'Sales assistant' },
  ];

  return (
    <RequiredSelect model={model}
                    values={values}
                    label={label}
                    disabled={disabled}
                    controlId="userJobTitle"/>
  )
};

UserJobTitleSelector.propTypes = {
  model: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
};

UserJobTitleSelector.defaultProps = {
  model: '.job_title',
  label: 'Job title',
  disabled: false
};

export default UserJobTitleSelector;



// WEBPACK FOOTER //
// ./src/components/common/form/user/user-job-title-selector.jsx